/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageGridJobConfigSchema
 */
export interface PageGridJobConfigSchema {
    /**
     * 
     * @type {any}
     * @memberof PageGridJobConfigSchema
     */
    items: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageGridJobConfigSchema
     */
    total: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageGridJobConfigSchema
     */
    page: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageGridJobConfigSchema
     */
    size: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageGridJobConfigSchema
     */
    pages: any | null;
}

/**
 * Check if a given object implements the PageGridJobConfigSchema interface.
 */
export function instanceOfPageGridJobConfigSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "pages" in value;

    return isInstance;
}

export function PageGridJobConfigSchemaFromJSON(json: any): PageGridJobConfigSchema {
    return PageGridJobConfigSchemaFromJSONTyped(json, false);
}

export function PageGridJobConfigSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageGridJobConfigSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': json['items'],
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': json['pages'],
    };
}

export function PageGridJobConfigSchemaToJSON(value?: PageGridJobConfigSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items,
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

